import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
export const convertImage = async ({ file, formData, key }) => {
  try {
    const jpegData = await heic2any({
      blob: file,
      toType: 'image/png',
      quality: 0.1
    });

    const jpegFile = new File([jpegData], `${file.name}.png`, {
      type: 'image/png'
    });
    jpegFile.path = file.path;
    const compressedFile = await imageCompression(jpegFile, {
      maxSizeMB: 0.05,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    });
    formData.append(key, compressedFile);
  } catch (err) {
    console.error(err);
    formData.append(key, file);
  }
};
